import SVTAPI from './svtapi';

class User extends SVTAPI {
  /**
   * Initializes a new, existing user.
   *
   * @param {string} email The email of the user
   */
  constructor(email) {
    super('/user');
    this._email = email;
  }

  /**
   * POST /user/:email/logIn
   * Logs user in.
   *
   * @param   {string} password The password to use for logging in
   * @returns {Object}          The server's response
   */
  logIn(password) {
    return super.post({ url: '/' + this._email + '/logIn', data: { password } });
  }

  /**
   * PATCH /user/:pid
   * Edits a user's details
   *
   * @param {Object} data - The new user details, e.g. { warehouse: 14 }
   * @param {Number} [pid] - An eshop user pid can be set here, otherwise an ERP user is assumed.
   * @returns {Object} - The server's response
   */
  patch(data, pid) {
    return super.patch({ url: '/' + pid, data });
  }
}

export default User;
